var map = {
	"./cat_en.json": "7ce8",
	"./cat_it.json": "45de",
	"./en.json": "edd4",
	"./faq_en.json": "70d2",
	"./faq_it.json": "3d97",
	"./it.json": "0825",
	"./skills_en.json": "989e",
	"./skills_it.json": "81a2",
	"./testimonial_en.json": "4ce1",
	"./testimonial_it.json": "90de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";